export const title =  "Gyan Rashmi | Quality Education from Pre to 10th";